/** Regras de destaque da nav principal (bottom + sidebar). */

import { stripHubPath } from './hubPath'

const PERFIL_PATHS = ['/perfil', '/cadastro', '/senha', '/ficha']

const REDE_EXACT = ['/rede', '/equipe', '/convidados', '/medalhas', '/ranking', '/pontuacao']

/** Prefixo Hub ↔ menu Campanha (paridade com MenuLiderancaHelper::resolveActiveBottomNavKey). */
const CAMPANHA_PREFIXES = [
  '/campanha',
  '/missoes',
  '/biografia',
  '/eu-apoio',
  '/colinha',
  '/agenda',
  '/noticias',
  '/videos',
  '/avisos',
  '/eventos',
  '/enquetes',
  '/legislacao',
  '/redes',
]

function pathMatchesPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`)
}

export function isNavItemActive(key: string, pathname: string, isActive: boolean): boolean {
  const p = stripHubPath(pathname)
  if (key === 'perfil') {
    return PERFIL_PATHS.includes(p)
  }
  if (key === 'rede') {
    return REDE_EXACT.includes(p) || p.startsWith('/arvore') || p.startsWith('/solicitacoes')
  }
  if (key === 'campanha') {
    return CAMPANHA_PREFIXES.some((prefix) => pathMatchesPrefix(p, prefix))
  }
  return isActive
}

export function spaTo(key: string): string {
  return `/hub/${key}`
}
